import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, } from "react-router-dom";
import { accountDetails } from "@di";
import LoginHOC from "@frameworks/web/components/features/LoginFlow/LoginHOC";
import { LogInMainPage } from "@frameworks/web/components/features/LoginFlow/ClientUser/LogInMainPage";
import di from "./di/servicelocator";
import { loginScreenState } from "./constant";
import ForgotLoginId from "./HelpFlow/ForgotLoginId";
import ForgotPassword from "./HelpFlow/ForgotPassword";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import UnblockAccount from "./HelpFlow/UnblockAccount";
import { isEqual } from "underscore";
const ShowLoginPopup = (props) => {
    const navigate = useNavigate();
    const [screenState, setScreenState] = React.useState(null);
    const { showLoginPopup } = useSelector((state) => state.LoginFlow.ClientValOTP, isEqual);
    const updateLoginPoupDetails = (loginPopup) => {
        di.login.updateLoginPopup(loginPopup);
        props.callBackFunction && (props === null || props === void 0 ? void 0 : props.callBackFunction());
    };
    const renderLoginUI = () => {
        if (accountDetails.isUserLoggedIn() && !showLoginPopup) {
            return React.createElement(React.Fragment, null, props.children);
        }
        else {
            switch (screenState) {
                case loginScreenState.LOGIN:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(LoginHOC, { component: LogInMainPage, title: "Login", setAfterLogin: (loginResponse) => {
                                updateLoginPoupDetails(false);
                            }, skipRedirectNavigation: true, parentCallBack: () => {
                                props === null || props === void 0 ? void 0 : props.popupCloseFunction();
                                setScreenState(loginScreenState.DEFAULT);
                            }, helpFlowPopup: (state) => {
                                setScreenState(state);
                            } })));
                case loginScreenState.FORGOT_LOGIN_ID:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(LoginHOC, { component: ForgotLoginId, title: "Forgot Login ID", setAfterLogin: (loginResponse) => {
                                updateLoginPoupDetails(false);
                            }, skipRedirectNavigation: true, parentCallBack: () => {
                                props === null || props === void 0 ? void 0 : props.popupCloseFunction();
                            }, helpFlowPopup: (state) => {
                                setScreenState(state);
                            } })));
                case loginScreenState.FORGOT_PASSWORD:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(LoginHOC, { component: ForgotPassword, title: "Forgot Password", setAfterLogin: (loginResponse) => {
                                updateLoginPoupDetails(false);
                            }, skipRedirectNavigation: true, parentCallBack: () => {
                                props === null || props === void 0 ? void 0 : props.popupCloseFunction();
                            }, UserType: ILoginFlows.CLIENT, helpFlowPopup: (state) => {
                                setScreenState(state);
                            } })));
                case loginScreenState.UNBLOCK_USER:
                    return (React.createElement(LoginHOC, { component: UnblockAccount, title: " Unblock your account", helpFlowPopup: (state) => {
                            setScreenState(state);
                        }, skipRedirectNavigation: true, parentCallBack: () => {
                            props === null || props === void 0 ? void 0 : props.popupCloseFunction();
                        } }));
                default:
                    return React.createElement(React.Fragment, null);
            }
        }
    };
    React.useEffect(() => {
        if ((!!showLoginPopup && !!screenState) ||
            accountDetails.isUserLoggedIn()) {
            renderLoginUI();
        }
    }, [screenState]);
    React.useEffect(() => {
        if (showLoginPopup !== undefined && showLoginPopup !== null) {
            if (screenState == null && !accountDetails.isUserLoggedIn()) {
                setScreenState(loginScreenState.LOGIN);
            }
            else {
                setScreenState(loginScreenState.DEFAULT);
            }
        }
        else {
            setScreenState(null);
            di.login.flushLoginData();
        }
    }, [showLoginPopup]);
    return React.createElement(React.Fragment, null, renderLoginUI());
};
export default ShowLoginPopup;
